import { defaultMeta } from '@/common/constants/defaultMeta.constant'

export const governmentAllocationsDistributionsTransformerResponse = <T>() => ({
  data: [] as T,
  meta: { ...defaultMeta, total_distributions_count: 0 },
})
